import { http } from '../../../../api/http';
import type { AsientoContable } from '../types/asientos';

const ENDPOINT = '/planilla/asiento-contable';

export class AsientosService {
  static async getByPlanilla(idPlanilla: number): Promise<AsientoContable[]> {
    const response = await http.get(`${ENDPOINT}/${idPlanilla}`);
    return response.data;
  }

  static async getById(idAsiento: number): Promise<AsientoContable> {
    const response = await http.get(`${ENDPOINT}/detalle/${idAsiento}`);
    return response.data;
  }

  static async generar(idPlanilla: number, tipoAsiento: string = 'PLANILLA'): Promise<AsientoContable> {
    const response = await http.post(`${ENDPOINT}/generar`, { idPlanilla, tipoAsiento });
    return response.data;
  }

  static async contabilizar(id: number): Promise<AsientoContable> {
    const response = await http.put(`${ENDPOINT}/contabilizar/${id}`);
    return response.data;
  }

  static async anular(id: number): Promise<AsientoContable> {
    const response = await http.put(`${ENDPOINT}/anular/${id}`);
    return response.data;
  }

  static async generarProvision(idPlanilla: number): Promise<AsientoContable> {
    const response = await http.post(`${ENDPOINT}/generar-provision`, { idPlanilla, tipoAsiento: 'PROVISION' });
    return response.data;
  }
}
